import script from "./StudentsTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentsTableItem.vue?vue&type=script&setup=true&lang=js"

import "./StudentsTableItem.vue?vue&type=style&index=0&id=008eddf6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008eddf6"]])

export default __exports__